import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import styles from './simulation.module.css';
import HeaderBlack from '../../components/header/headerBlack/headerBlack';
import StatusCard from '../../components/statusCard/statusCard';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

const Simulation = () => {
  const location = useLocation();
  const { patientData, patientId } = location.state || {};
  const etapes = {
    "Lite arcade unique": 7,
    "Lite deux arcade": 7,
    "Lite": 7,

    "Essential": 12,
    "Essential deux arcade": 12,
    "Essential arcade unique": 12,

    "Smart": 24,
    "Smart deux arcade": 24,
    "Smart arcade unique": 24,

    "Pro": 36,
    "ProPlus": 36
}
const prix = {
    "Lite arcade unique": 850,
    "Lite deux arcade": 1300,
    "Lite": 850,

    "Essential": 1150,
    "Essential deux arcade": 1950,
    "Essential arcade unique": 1150,

    "Smart": 2100,
    "Smart deux arcade": 3150,
    "Smart arcade unique": 2100,

    "Pro": 4500,
    "ProPlus": 5000
}
  const [restrictedTeeth, setRestrictedTeeth] = useState([]);
  const [taquetTeeth, setTaquetTeeth] = useState([]);

  useEffect(() => {
    const checkValidationStatus = async () => {
      if (patientId) {
        const patientRef = doc(db, 'patients', patientId);
        const patientDoc = await getDoc(patientRef);
        if (patientDoc.exists()) {
          const data = patientDoc.data();
          
          // Get teeth numbers from prescription data
          if (data.prescription) {
            setRestrictedTeeth(data.prescription.selectedTeeth || []);
            setTaquetTeeth(data.prescription.taquetsTeeth || []);
          }
        }
      }
    };
    checkValidationStatus();
  }, [patientId]);

  const navigate = useNavigate();

  return (
    <div>
        <HeaderBlack />
        <main>
        <StatusCard />
        <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
            <h2 className={styles.title}>Simulation Patient</h2>
            <button className={styles.closeButton} onClick={() => navigate('/dossier', { 
                state: { 
                    patient: patientData
                }
            })}>✕</button>
        </div>
        
        {/* Main Content */}
        <div className={styles.content}>
            {/* Left Section - Doctor Info and 3D Viewer */}
            <div className={styles.mainSection}>
            {/* 3D Viewer */}
            <div className={styles.modelContainer}>
                 {/* Embedded 3D Viewer iframe */}
              <iframe 
                src={patientData.TPCheck}
                className={styles.modelIframe}
                title="3D Dental Model"
                frameBorder="0"
                allowFullScreen
              />
            </div>
                
            </div>
        </div>
        </div>
       </main> 
    </div>
  );
};

export default Simulation;